import {Link} from "react-router-dom";
import {StyledCreateButtonWrapper} from "../../../../layouts/dashboard-wrapper/dashboard-wrapper.style";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";

export function CreateNewServiceButton() {
  return (
    <StyledCreateButtonWrapper>
      <Link to="/products/services/new">
        <Button block type="primary" size="small">
          <span className="show-desktop">Create a new service</span>
          <span className="show-mobile">
            <PlusOutlined style={{fontSize: "2.4rem"}} />
          </span>
        </Button>
      </Link>
    </StyledCreateButtonWrapper>
  );
}
